import APIconsume from 'Main/APIconsume'
import { minPageSizeConfigs } from 'Main/Utils'

const BASE_URL = '/api/dashboard/inquiry-callback'

class InquiryCallbackService {
  constructor () {
    this._apiConsume = new APIconsume()
  }

  /** Read-only dashboard list. */
  async getData ({ page = 1, size = minPageSizeConfigs, trxId = '', deviceName = '%', inquiryType = '%', status = '%', from = '', to = '', userId = 'ALL' } = {}) {
    const params = new URLSearchParams({ page, size, trxId, device_name: deviceName, inquiryType, status, from, to, user_id: userId }).toString()
    const result = await this._apiConsume.getData(`${BASE_URL}?${params}`)
    return result?.data
  }

  /** Read-only dashboard detail. */
  async getById (id) {
    const result = await this._apiConsume.getData(`${BASE_URL}/${id}`)
    return result?.data
  }

}

export default InquiryCallbackService
